// VisualViewport dimensions shrink during pinch zoom as well as keyboard entry.
// Keep shell dimensions in layout CSS pixels before detecting a keyboard.
export function viewportMetrics({ layoutHeight, visualHeight, scale = 1, offsetTop = 0, editableFocused = false }) {
  const layout = Number.isFinite(layoutHeight) && layoutHeight > 0 ? layoutHeight : 1;
  const zoom = Number.isFinite(scale) && scale > 0 ? scale : 1;
  const visible = Number.isFinite(visualHeight) && visualHeight > 0 ? visualHeight * zoom : layout;
  const height = Math.max(1, Math.round(Math.min(layout, visible)));
  const top = Number.isFinite(offsetTop) ? Math.max(0, offsetTop * zoom) : 0;
  const keyboardInset = editableFocused ? Math.max(0, Math.round(layout - height - top)) : 0;
  return { height, keyboardInset, keyboardVisible: keyboardInset > 120 };
}

export function readAppViewport(view = window) {
  const viewport = view.visualViewport;
  const active = view.document.activeElement;
  const editableFocused = Boolean(active?.isContentEditable || active?.matches?.(
    'textarea, select, input:not([type=button]):not([type=submit]):not([type=reset]):not([type=checkbox]):not([type=radio]):not([type=range]):not([type=color])'
  ));
  return viewportMetrics({
    layoutHeight: Math.max(view.innerHeight || 0, view.document.documentElement.clientHeight || 0),
    visualHeight: viewport?.height,
    scale: viewport?.scale,
    offsetTop: viewport?.offsetTop,
    editableFocused
  });
}
